import { Button } from "@mantine/core";
import { useState } from "react";
import ReactDOM from "react-dom";

interface DeliveryFormControlsProps {
  buttonContainer?: HTMLElement;
  onCancel: () => void;
  onSubmit: () => Promise<void>;
}

function DeliveryFormControls({
  buttonContainer,
  onCancel,
  onSubmit
}: DeliveryFormControlsProps) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleClickSubmit() {
    setIsSubmitting(true);

    try {
      await onSubmit();
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="DeliveryFormControls">
      {buttonContainer &&
        ReactDOM.createPortal(
          <>
            <Button
              color="secondary"
              loading={isSubmitting}
              onClick={handleClickSubmit}
            >
              Speichern
            </Button>
            <Button variant="default" onClick={onCancel}>
              Abbrechen
            </Button>
          </>,
          buttonContainer
        )}
    </div>
  );
}

export { DeliveryFormControls, DeliveryFormControlsProps };
